module.exports = __webpack_public_path__ + "img/q5.4a91a6d5.png";